import React from 'react';
import './BrandBackdrop.css';

/** Ambient page decoration, separate from the unchanged logo artwork. */
const BrandBackdrop: React.FC = () => (
  <div className="brand-backdrop" aria-hidden="true">
    <div className="brand-backdrop__grid" />
    <div className="brand-backdrop__orbit" />
    <div className="brand-backdrop__orbit brand-backdrop__orbit--inner" />
  </div>
);

export default BrandBackdrop;
